export default __webpack_public_path__ + "static/media/score.156804ee.jpg";